import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Grid, Typography } from "@material-ui/core";
import Draggable from "react-draggable";

const DraggableAnswer = (props) => {
  const {
    showDraggable,
    onDragStart,
    onDragEnd,
    onDragUpdate,
    currentQuestion,
    dragStarted,
    classes,
  } = props;

  const TextWithNoWidow = ({ children }) => {
    const modifiedChildren = React.Children.map(children, (child) => {
      if (typeof child === 'string') {
        const words = child.trim().split(' ');
        if (words.length > 1) {
          const lastWord = words.pop();
          const secondLastWord = words.pop();
          return [...words, `${secondLastWord}\u00A0${lastWord}`].join(' ');
        }
      }
      return child;
    });
    return <Typography className={classes.serviceDesc} dangerouslySetInnerHTML={{__html: modifiedChildren}}></Typography>
    // return <p>{modifiedChildren}</p>;
  };

  return (
    <Grid className={classes.draggableMainContainer}>
      <Grid className={classes.draggableContainer}>
        {showDraggable && (
          <Draggable
            onDrag={onDragUpdate}
            onStart={onDragStart}
            onStop={onDragEnd}
            position={{ x: 0, y: 0 }}
            handle="#answer-icon"
          >
            <Grid
              container
              alignItems="center"
              className={classes.draggableElement}
            >
              <img
                id="answer-icon"
                src={currentQuestion.icon}
                className={`${classes.questionImg} animate__animated animate__bounceIn`}
              />
              <Grid className="animate__animated animate__bounceIn">
                <Typography className={classes.serviceTitle}>
                  {currentQuestion.title}
                </Typography>
                <TextWithNoWidow>{currentQuestion.desc}</TextWithNoWidow>

                {/* <Typography className={classes.serviceDesc}>
                  {currentQuestion.desc}
                  <Typography className={classes.boldText} dangerouslySetInnerHTML={{__html: currentQuestion.boldText}}></Typography>
                </Typography> */}
              </Grid>
            </Grid>
          </Draggable>
        )}
      </Grid>
      {(dragStarted || !showDraggable) && (
        <Grid className={classes.iconTraceBack} />
      )}
    </Grid>
  );
};

export default withStyles(styles)(DraggableAnswer);
